import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import styles from "./LegalPage.module.scss";

export function TermsOfServicePage() {
  return (
    <div className={styles.page}>
      <Helmet>
        <title>Terms of Service | GoodBaby</title>
        <meta
          name="description"
          content="Terms and conditions for using GoodBaby."
        />
        <link rel="canonical" href="https://goodbaby.cam/terms" />
      </Helmet>
      <header className={styles.header}>
        <div className={styles.container}>
          <Link to="/" className={styles.backLink}>
            <ArrowLeft size={16} />
            Home
          </Link>
        </div>
      </header>

      <main className={styles.main}>
        <div className={styles.container}>
          <h1>Terms of Service</h1>
          <p className={styles.lastUpdated}>Last updated: January 2026</p>

          <section className={styles.section}>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using GoodBaby, you accept and agree to be bound
              by the terms and provision of this agreement.
            </p>
          </section>

          <section className={styles.section}>
            <h2>2. Description of Service</h2>
            <p>
              GoodBaby provides a web-based baby monitoring service that allows
              users to stream video and audio between their own devices
              ("Service"). The service utilizes Peer-to-Peer technology.
            </p>
          </section>

          <section className={styles.section}>
            <h2>3. User Responsibilities</h2>
            <p>You are responsible for:</p>
            <ul>
              <li>The safety and security of your own devices.</li>
              <li>
                Ensuring your devices are charged and connected to the internet
                while using the service.
              </li>
              <li>
                Not relying solely on GoodBaby for critical medical monitoring.
                This service is a consumer aid, not a medical device.
              </li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>4. Limitation of Liability</h2>
            <p>
              GoodBaby is provided "as is". We are not liable for any failure of
              the service, including reliable connection failures, internet
              outages, or device battery failures. Always have a backup plan for
              monitoring your child.
            </p>
          </section>

          <section className={styles.section}>
            <h2>5. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Your
              continued use of the service constitutes agreement to such
              modifications.
            </p>
          </section>
        </div>
      </main>

      <footer className={styles.footer}>
        <div className={styles.container}>
          <p>© {new Date().getFullYear()} GoodBaby. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
